/* eslint-disable @typescript-eslint/no-explicit-any */
// TODO: This file was automatically migrated to TypeScript by `dev typescript migrate`.
//  The eslint disable comment above should be removed and the resulting errors fixed.
import {css, StyleSheet} from 'aphrodite';
import classNames from 'classnames';
import React from 'react';

import getPolicyName from 'auth/getPolicyName';
import {OwnerInfo} from 'auth/PermissionConstants';
import {Policy} from 'auth/PolicyConstants';
import BenchlingConfig from 'BenchlingConfig';
import ModelTypeConstants from 'constants/ModelTypeConstants';
import {Entity} from 'constants/UserConstants';
import {getPartyDisplayString} from 'parties/GetPartyDisplayString';
import FormGroup from 'ui-library/bs/FormGroup';
import Label from 'ui-library/bs/Label';
import SelectDropdown from 'ui-library/dropdowns/SelectDropdown';
import Menu from 'ui-library/menus/Menu';
import Option from 'ui-library/menus/Option';

import CollaboratorRowView, {NONE} from './CollaboratorRowView';

export const NO_PERMISSION = 'NO_PERMISSION';

interface OwnerRowViewProps {
  isReadOnly: boolean;
  owner?: Entity;
  onChangeOwnerPolicy: (...args: Array<any>) => any;
  ownerInfo?: OwnerInfo;
  policies?: Array<Policy>;
  renderExtraColumns?: ((...args: Array<any>) => any) | null;
}

export class OwnerRowView extends React.Component<OwnerRowViewProps> {
  handleChangeOwnerDataPolicy = (memberDataPolicyId: string | null): void => {
    const nullablePolicyId = memberDataPolicyId !== NO_PERMISSION ? memberDataPolicyId : null;
    this.props.onChangeOwnerPolicy(nullablePolicyId);
  };

  render(): JSX.Element {
    const currentPolicy = this.props.policies?.find(
      (policy) => policy.id === this.props.ownerInfo?.memberDataPolicyId
    );
    return (
      <tr>
        <td className={css(styles.partyCell)}>
          {this.props.ownerInfo?.type === ModelTypeConstants.ORGANIZATION && 'Members of '}
          <strong>{getPartyDisplayString(this.props.owner!)}</strong>
        </td>
        <td>
          {this.props.ownerInfo?.type === ModelTypeConstants.USER ? (
            'ADMIN'
          ) : (
            <SelectDropdown
              displayName={currentPolicy ? getPolicyName(currentPolicy) : NONE}
              disabled={this.props.isReadOnly}
              menu={
                <Menu
                  height={Menu.HEIGHTS.MEDIUM}
                  width={Menu.WIDTHS.FULL}
                  scrollable={true}
                  value={currentPolicy ? getPolicyName(currentPolicy) : NO_PERMISSION}
                >
                  <Option value={NO_PERMISSION} onSelect={this.handleChangeOwnerDataPolicy}>
                    NONE
                  </Option>
                  {this.props.policies!.map((dataPolicy) => (
                    <Option
                      key={dataPolicy.id}
                      value={dataPolicy.id}
                      onSelect={this.handleChangeOwnerDataPolicy}
                    >
                      {getPolicyName(dataPolicy)}
                    </Option>
                  ))}
                </Menu>
              }
            />
          )}
        </td>
        {this.props.renderExtraColumns && this.props.renderExtraColumns(this.props.owner!.id)}
        {!this.props.isReadOnly && <td />}
        <td />
      </tr>
    );
  }
}

interface CreatorRowViewProps {
  creatorPolicy: Policy;
}

function CreatorRowView(props: CreatorRowViewProps): JSX.Element {
  return (
    <tr>
      <td className={css(styles.partyCell)}>
        <strong>Schema Creator</strong>
      </td>
      <td>{props.creatorPolicy.name}</td>
    </tr>
  );
}

export type CreatorRowViewPropsGroup =
  | {showSchemaCreatorRow: true; creatorPolicy: Policy}
  | {showSchemaCreatorRow: false};

interface CollaboratorsFormGroupProps {
  collaborators: Array<any>;
  isReadOnly: boolean;
  onChangeCollaboratorPolicy: (...args: Array<any>) => any;
  onChangeOwnerPolicy: (...args: Array<any>) => any;
  onLeave?: (...args: Array<any>) => any;
  onRemoveCollaborator: (...args: Array<any>) => any;
  owner?: Entity;
  ownerInfo?: OwnerInfo;
  policies?: Array<Policy>;
  creatorRowPropsGroup?: CreatorRowViewPropsGroup;
  renderExtraColumnHeaders?: ((...args: Array<any>) => any) | null;
  renderExtraColumns?: ((...args: Array<any>) => any) | null;
}

class CollaboratorsFormGroup extends React.Component<CollaboratorsFormGroupProps> {
  render(): JSX.Element {
    return (
      <FormGroup>
        <Label>Collaborators</Label>
        <table
          className={classNames(
            css(styles.table),
            'library-collaborators table table-hover u-no-spacing-bottom'
          )}
        >
          <thead>
            <tr>
              <th className={css(styles.partyCell)}>
                User{BenchlingConfig.ENABLE_BENCHLING_APPS ? ' / App' : ''} / Organization
                {BenchlingConfig.ENABLE_TEAMS ? ' / Team' : ''}
              </th>
              <th className={css(styles.permissionsCell)}>Access policies</th>
              {this.props.renderExtraColumnHeaders && this.props.renderExtraColumnHeaders()}
              {!this.props.isReadOnly && <th />}
              <th />
            </tr>
          </thead>
          {this.props.owner && (
            <tbody>
              <OwnerRowView
                isReadOnly={this.props.isReadOnly}
                owner={this.props.owner}
                ownerInfo={this.props.ownerInfo}
                onChangeOwnerPolicy={this.props.onChangeOwnerPolicy}
                policies={this.props.policies}
                renderExtraColumns={this.props.renderExtraColumns}
              />
            </tbody>
          )}
          {this.props.creatorRowPropsGroup && this.props.creatorRowPropsGroup.showSchemaCreatorRow && (
            <tbody>
              <CreatorRowView creatorPolicy={this.props.creatorRowPropsGroup.creatorPolicy} />
            </tbody>
          )}
          <tbody>
            {(() => {
              const result: any = [];
              this.props.collaborators.forEach((collaborator, i) => {
                // If the owner is already displayed, skip
                if (this.props.owner && collaborator.id === this.props.owner.id) {
                  return;
                }
                result.push(
                  <CollaboratorRowView
                    isReadOnly={this.props.isReadOnly}
                    key={i}
                    collaborator={collaborator}
                    onChangeCollaboratorPolicy={this.props.onChangeCollaboratorPolicy}
                    onLeave={this.props.onLeave}
                    onRemoveCollaborator={this.props.onRemoveCollaborator}
                    policies={this.props.policies!}
                    renderExtraColumns={this.props.renderExtraColumns}
                  />
                );
              });
              return result;
            })()}
          </tbody>
        </table>
      </FormGroup>
    );
  }
}

const styles = StyleSheet.create({
  table: {
    tableLayout: 'fixed',
  },
  partyCell: {
    width: '35%',
    overflowWrap: 'break-word',
    wordWrap: 'break-word',
  },
  permissionsCell: {
    width: '35%',
  },
});

export default CollaboratorsFormGroup;
